import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react'
import { addDays, format, startOfDay } from 'date-fns'
import React from 'react'

interface AreaHeaderContentProps {
    startDate: string,
    setStartDate: (data: string) => void
    endDate: string,
    setEndDate: (date: string) => void
    setModalFilterOpen: (isOpen: boolean) => void
}

const AreaHeaderContent: React.FC<AreaHeaderContentProps> = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate
}) => {
    const handleMoveBack = () => {
        const currentStartDate = startOfDay(new Date(startDate));  // Start of the day for the current start date
        const newStartDate = addDays(currentStartDate, -30);  // Move 30 days back

        // Calculate new endDate as 30 days after the newStartDate
        const newEndDate = addDays(newStartDate, 30);

        // Update startDate and endDate
        setStartDate(format(newStartDate, 'yyyy-MM-dd'));  // Set the new start date
        setEndDate(format(newEndDate, 'yyyy-MM-dd'));  // Set end date as 30 days after new start date
    }

    const handleResetToday = () => {
        const today = startOfDay(new Date());  // Get today's start of day
        const newEndDate = addDays(today, 30);  // Calculate 30 days after today

        setStartDate(format(today, 'yyyy-MM-dd'));  // Set startDate to today's date
        setEndDate(format(newEndDate, 'yyyy-MM-dd'));  // Set endDate to 30 days from today
    }

    const handleMoveNext = () => {
        const currentEndDate = startOfDay(new Date(endDate));  // Start of the day for the current end date
        const newEndDate = addDays(currentEndDate, 30);  // Move 30 days forward

        // Calculate new startDate as 30 days before the newEndDate
        const newStartDate = addDays(newEndDate, -30);

        // Update startDate and endDate
        setStartDate(format(newStartDate, 'yyyy-MM-dd'));  // Set start date as 30 days before the new end date
        setEndDate(format(newEndDate, 'yyyy-MM-dd'));  // Set the new end date
    }

    return (
        <div className="d-block">
            <div className="d-flex justify-content-between w-100">
                <h3 className="fs-2 text-secondary d-none d-sm-block">Reservation Calendar</h3>
            </div>

            <div className="d-flex flex-column flex-sm-row mt-sm-2 w-100 m-auto">
                <button
                    className="btn btn-sm btn-outline-primary btn-pill me-sm-1 mb-2 mb-sm-0"
                    onClick={() => handleMoveBack()}
                >
                    <IconArrowLeft size={12} />
                </button>

                <button
                    className="btn btn-sm btn-outline-primary w-100 btn-pill me-sm-1 mb-2 mb-sm-0 d-flex align-items-center justify-content-center"
                    onClick={() => handleResetToday()}
                >
                    TODAY
                </button>

                <button
                    className="btn btn-sm btn-outline-primary btn-pill"
                    onClick={() => handleMoveNext()}
                >
                    <IconArrowRight size={12} />
                </button>
            </div>
        </div>
    )
}

export default AreaHeaderContent